export default "__VITE_ASSET__uCEuIo3w__"